import { render, staticRenderFns } from "./OtherAppBox.vue?vue&type=template&id=a3132638&scoped=true"
import script from "./OtherAppBox.vue?vue&type=script&lang=js"
export * from "./OtherAppBox.vue?vue&type=script&lang=js"
import style0 from "./OtherAppBox.vue?vue&type=style&index=0&id=a3132638&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3132638",
  null
  
)

export default component.exports